import { Button, Checkbox, DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSmc3Control extends Layout {
    buttonCreateCompany: Button;
    buttonDeactivateTracking: Button;
    buttonInitiateTracking: Button;
    buttonTestConnection: Button;
    checkIncludeSaturday: Checkbox;
    checkIncludeSunday: Checkbox;
    checkboxEnableTestMode: Checkbox;
    checkboxEnableWebTendering: Checkbox;
    checkboxActive: Checkbox;
    labelTransitDays: Label;
    panelActive: Panel;
    panelButtons: Panel;
    panelSmc3Control: Panel;
    panelTransitDays: Panel;
    sourceContractManagementControl: DataSource;
    textboxAccountPassword: Textbox;
    textboxAccountUserId: Textbox;
    textboxEndpointUrl: Textbox;
    textboxRefSetting1: Textbox;
    textboxRefSetting2: Textbox;
    textboxSmc3ProfileId: Textbox;
}
